import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {addRegParams} from '../models/registers.interface';

@Injectable({
  providedIn: 'root',
})
export class AddRegisterService {
  constructor() {}
  addReg(router: Router, params: addRegParams): void {
    router.navigate([`/proyectos/${params.projectID}/registros/nuevo`], {
      queryParams: {
        attID: params.attID,
      },
    });
  }
}
